import { SupportedRegions } from "@nova/constants"
import { S3IngestEvent } from "@nova/schemas"
import { getApiGatewayDomainForRegion } from "@nova/configuration"

export type MockIngestParams = {
    url?: string
    credentials?: RequestCredentials
    headers?: Record<string, string>
    body: Omit<S3IngestEvent, "source">
}

/** For localhost use only. */
export function triggerMockIngest({
    url = getApiGatewayDomainForRegion(SupportedRegions.Canada),
    credentials,
    headers,
    body,
}: MockIngestParams): Promise<Response> {
    return fetch(url, {
        method: "POST",
        ...(headers ? { headers } : {}),
        ...(credentials ? { credentials } : {}),
        body: JSON.stringify(body),
    })
}
